import styles from './TableCardView.module.scss';
import { Card } from 'antd';
import classNames from 'classnames';
import { TableColumnType } from '../Table';
import { getColumnKey, getColumnLabel, renderCell } from './tableCardViewUtils';

interface Props<T> {
  columns: TableColumnType<T>[];
  record: T;
  index: number;
  className?: string;
}

export function TableCardViewCard<T extends object>(props: Props<T>) {
  const { columns, record, index, className } = props;

  // Columns without a text title (e.g. the color / marker column) are shown as
  // a leading badge in the card header; the rest become labelled rows.
  const badgeColumns = columns.filter((c) => getColumnLabel(c) == null);
  const rowColumns = columns.filter((c) => getColumnLabel(c) != null);

  return (
    <Card size="small" className={classNames(styles.card, className)}>
      {badgeColumns.length > 0 && (
        <div className={styles.badges}>
          {badgeColumns.map((column, i) => (
            <span key={getColumnKey(column, i)}>
              {renderCell(column, record, index)}
            </span>
          ))}
        </div>
      )}
      <div className={styles.rows}>
        {rowColumns.map((column, i) => (
          <div className={styles.row} key={getColumnKey(column, i)}>
            <span className={styles.label}>{getColumnLabel(column)}:</span>
            <span className={styles.value}>
              {renderCell(column, record, index)}
            </span>
          </div>
        ))}
      </div>
    </Card>
  );
}
